














import {
  Vue,
  Component
} from "@/shared/vuepack";
import SettingsHeader from "@/employee/components/settings/SettingsHeader.vue";
import SettingsNavigation from "@/employee/components/settings/SettingsNavigation.vue";
import LinkedAccounts from "@/employee/components/shared/LinkedAccounts.vue";

@Component({
  components: {
    SettingsNavigation,
    LinkedAccounts,
    SettingsHeader,
  }
})
export default class LinkedAccountsSettings extends Vue { }
